module.exports = __webpack_public_path__ + "static/media/hn.efffed4e.svg";